import { dataDoubleCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDoubleCircle = /*#__PURE__*/createIcon(dataDoubleCircle)
export default IconDoubleCircle
